<div class="box-container w-auto h-full flex u-gap-16">
    <app-empresa-dropdown *ngIf="exibeEmpresa"></app-empresa-dropdown>
    <!-- <app-language-setup></app-language-setup> -->
    <div class="notification-wrapper" (click)="openNotificacaoBar()">
        <i class="fas fa-bell notification-icon"></i>
        <div *ngIf="quantidadeNotificacoesNaoLidas > 0" class="box-notification-count">
            {{quantidadeNotificacoesNaoLidas}}
        </div>
    </div>
    <div class="w-2 h-20 u-bg-white">

    </div>
    <div (click)="openClickSettings()" class="w-auto flex u-gap-8 open-settings-trigger">
        <div *ngIf="model" style="cursor: pointer;" class="w-auto box-hello u-text-white flex fw-500">
            <p> {{'COMMON.HELLO' | translate}} {{model.nome}}</p>
            <i [ngClass]="openSettings ? 'icon-profile-header-rotate':'icon-profile-header'" style="cursor: pointer;"
                matTooltipPosition="right" matTooltip="Descrição"
                class="material-symbols-outlined u-mt-2  u-fs-24">keyboard_arrow_down</i>
        </div>
        <div style="cursor: pointer;" class="w-40 h-40 u-bg-gray-old box-image-person shadow-medium radius-full">
            <img class="w-full radius-full h-full" [src]="avatarUrl" alt="User image">
        </div>
    </div>

</div>

<div @fadeBox *ngIf="openSettings" class="box-settings-profile shadow-small">
    <div class="w-full u-p-16">
        <div class="flex-column h-full  w-full flex u-gap-20">
            <div class="flex h-auto w-full  box-items-setting u-gap-10">

                <div class="w-35 h-35 border-gray-old u-bg-gray-old radius-full">
                    <img class="w-full radius-full h-full" [src]="avatarUrl" alt="User image">
                </div>

                <div *ngIf="model" class="flex-column u-gap-2 u-fs-11 u-text-gray-text">
                    <p class="u-fs-12">
                        {{model.nome ? model.nome : 'username'}}
                    </p>
                    <p style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{model.email ? model.email : 'email@example.com'}}
                    </p>
                </div>
            </div>
            <div class="w-full u-bg-gray-old flex h-1">
            </div>
            <div class="w-full h-auto u-gap-10 flex-column">
                <div class="flex w-full h-auto" *ngFor="let data of linksSettings">
                    <span (click)="openLinkSettings(data.link)" style="cursor: pointer;"
                        class="flex  box-items-setting w-full u-gap-5 u-fs-12 u-text-gray-text">
                        <i class="material-symbols-outlined">{{data.icon}}</i>
                        {{data.text | translate }}
                    </span>
                </div>
            </div>
            <div class="w-full u-bg-gray-old flex h-1">

            </div>
            <div class="h-auto w-full flex">
                <span (click)="exit()" style="cursor: pointer;"
                    class="flex w-full  box-items-setting u-gap-5 u-fs-12 u-text-gray-text">
                    <i class="material-symbols-outlined">logout</i>
                    {{'COMMON.EXIT' | translate}}
                </span>
            </div>
        </div>
    </div>